import React from "react";
import { Link } from "react-router-dom";
import { Wind, Snowflake, Fan, GitBranch, Wrench, ShieldCheck, ArrowRight, Phone } from "lucide-react";
import { Button } from "../components/ui/button";
import { COMPANY, SERVICES_ICONS } from "../lib/constants";
import { useLang } from "../lib/i18n";

const ICONS = { Wind, Snowflake, Fan, GitBranch, Wrench, ShieldCheck };

export default function ServicesPage() {
  const { t } = useLang();
  const items = t.services.items;

  return (
    <>
      <section className="section-y border-b border-border" data-testid="services-hero">
        <div className="container-x max-w-4xl">
          <span className="overline">{t.services.overlinePage}</span>
          <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            {t.services.titlePage}
          </h1>
          <p className="mt-6 text-lg text-muted-foreground max-w-2xl">
            {t.services.subtitlePage}
          </p>
        </div>
      </section>

      <section className="section-y" data-testid="services-grid">
        <div className="container-x grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((s, i) => {
            const Icon = ICONS[SERVICES_ICONS[i]] || Snowflake;
            return (
              <article
                key={i}
                data-testid={`service-card-${i}`}
                className="group flex flex-col rounded-2xl border border-border bg-card p-7 hover:-translate-y-1 hover:shadow-xl hover:border-primary/40 transition-all duration-300"
              >
                <div className="h-12 w-12 rounded-xl bg-primary/10 text-primary grid place-items-center group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <Icon size={24} strokeWidth={2.25} />
                </div>
                <h3 className="mt-6 font-display font-bold text-xl">{s.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed flex-1">{s.description}</p>
                <Link to="/contact" state={{ service: s.title, serviceIndex: i }} className="mt-6" data-testid={`service-card-cta-${i}`}>
                  <Button className="w-full bg-primary hover:bg-primary/90 text-primary-foreground gap-2 rounded-full h-11 font-semibold">
                    {t.common.requestService} <ArrowRight size={16} />
                  </Button>
                </Link>
              </article>
            );
          })}
        </div>
      </section>

      <section className="border-t border-border bg-secondary/40" data-testid="services-bottom-cta">
        <div className="container-x py-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-display font-bold text-2xl sm:text-3xl">{t.services.bottomCtaTitle}</h3>
            <p className="text-muted-foreground mt-1">{t.services.bottomCtaDesc}</p>
          </div>
          <a href={COMPANY.phoneHref} data-testid="services-call-now">
            <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground gap-2 rounded-full h-12 px-7 font-semibold">
              <Phone size={18} /> {COMPANY.phoneDisplay}
            </Button>
          </a>
        </div>
      </section>
    </>
  );
}
